import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDevelopmentAppraisalService } from "../../Api/Project/DefaultServices/DevelopmentAppraisalService/DevelopmentAppraisalApiService";
import { mapDevelopmentAppraisalDataLists } from "../Types/Project/DefaultModels/DevelopmentAppraisal/DevelopmentAppraisalDataList";

// get all spending project list
export const getAllDevelopmentAppraisalList = createAsyncThunk(
  "getAllDevelopmentAppraisalList",
  async (folder_id: number, { rejectWithValue }) => {
    try {
      // api
      const response = await getDevelopmentAppraisalService(folder_id);
      if (response.status) {
        return mapDevelopmentAppraisalDataLists(response.body);
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch all projet details");
    }
  }
);
